// extracted by mini-css-extract-plugin
export var deliveryRow = "_pa-a";
export var fixedHeight = "_pa-4";
export var freightLogo = "_pa-9";
export var fullWidth = "_pa-3";
export var priceColumn = "_pa-5";
export var radioSelected = "_pa-7";
export var radioUnselected = "_pa-6";
export var selectedOption = "_pa-2";
export var selectedOptionContainer = "_pa-1";
export var selection = "_pa-0";
export var tallSkeletonText = "_pa-8";